import * as Sentry from '@sentry/react'

const DSN = import.meta.env.VITE_SENTRY_DSN
const ENV = import.meta.env.MODE

export function initSentry() {
  if (!DSN) {
    if (ENV !== 'development') console.warn('[sentry] VITE_SENTRY_DSN missing')
    return
  }
  Sentry.init({
    dsn: DSN,
    environment: ENV === 'production' ? 'production' : 'development',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true })],
    tracesSampleRate: ENV === 'production' ? 0.1 : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
    beforeSend(event) {
      // Scrubber PII côté front
      if (event.request?.cookies) delete event.request.cookies
      return event
    },
  })
}

export { Sentry }
